/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import * as React from 'react';
import { Route } from 'react-router-dom';
import { ErrorComp } from './UserListView/htm';

export function ErrorPage({ match }) {
  return (
    <>
      <Route exact path={match.url} component={ErrorComp} />
    </>
  );
}
